/* What „Masz niezapisany program" adds to `shared/ui/dialogSurface.module.css`: its width, its
 * entrance, the scrim it holds through a hand-over, and one line of consequence. The box, the title,
 * the description and the three answer treatments are that file's, worn alongside these classes.
 *
 * The scrim fades and the card fades, rises 8px and settles from 97% scale — opacity and transform
 * only. Its rows follow with the shared `rise` cascade (`shared/design-system/motion`), which is a
 * Motion animation and takes `reducedMotion` as a parameter. There is no media query here:
 * `tokens/base.css` collapses these CSS transitions under `prefers-reduced-motion`, and a feature
 * stylesheet may not carry a second block. */

/* The scrim is `shared/ui/splitDialog`'s — the SAME treatment as the create window this prompt
 * hands over to, blur and all — so the page behind does not change when one window replaces the
 * other. Held at full strength through a hand-over's exit; the create window's scrim then arrives
 * already at full strength (`CreatePlanDialog.module.css`), so the two meet with no dip. Doubled
 * class for the specificity: it has to beat the shared file's `[data-ending-style]` whatever order
 * the two chunks load in. */
.holdScrim.holdScrim[data-ending-style] {
  opacity: 1;
}

/* 460 rather than the confirm's 520: one card, one sentence and three short answers. The surface
 * reads the width from `--dialog-w` and never declares one, so it is written only here. */
.popup {
  --dialog-w: 460px;

  transition-property: opacity, transform;
  transition-duration: var(--dur-base);
  transition-timing-function: var(--ease);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: translate(-50%, calc(-50% + var(--space-2))) scale(0.97);
}

.head {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
